const pluralize = (count, word, suffix = "s", hideIfZero = false, replaceWord) =>
  hideIfZero && count === 0
    ? ""
    : `${count} ${count !== 1 ? (replaceWord ? replaceWord : `${word}${suffix}`) : word}`;

export default pluralize;
